import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'
import { Modal } from 'bootstrap'

export default class extends Controller {
  showPreviousItem(event) {
    this.openModal(event, event.currentTarget.dataset.previousItemModalId)
  }

  showNextItem(event) {
    this.openModal(event, event.currentTarget.dataset.nextItemModalId)
  }

  openModal(event, modalId) {
    event.preventDefault()

    get(event.currentTarget.href, { responseKind: 'turbo-stream' }).then(
      (response) => {
        if (response.ok) {
          new Modal(modalId).show()
        }
      }
    )
  }
}
